import { getLinks } from "../../../shared/functions/fns.nav";
import Loader from "@phoenixreisen/mithrils/src/loader";
import m from "mithril";
export default {
    show: false,
    oninit({ state, attrs }) {
        state.links = null;
        state.error = null;
        if (!attrs.links && !attrs.error) {
            getLinks()
                .then((links) => {
                state.links = links;
            })
                .catch((e) => {
                state.error = e;
            });
        }
    },
    view({ state, attrs }) {
        const error = attrs.error || state.error;
        const links = attrs.links || state.links;
        if (!links && !error) {
            return (m("div", { class: "tc mt4" },
                m(Loader, { text: "Links werden geladen..." })));
        }
        if (error) {
            return (m("div", { class: "alert alert--danger alert--icon mt3" },
                m("i", { class: "fas fa-times" }),
                "Links konnten nicht geladen werden. Bitte Seite erneut laden."));
        }
        return [
            m("h3", null, "Weitere Pr\u00E4senzen"),
            m("ul", null, links.PUBLIC.map((link) => (m("li", null,
                m("a", { href: link.href },
                    m("i", { class: "fas fa-angle-right mr2" }),
                    link.name))))),
        ];
    },
};
